import { Directive, Output, EventEmitter, HostBinding, HostListener } from '@angular/core'

@Directive({
    selector: '[appDragDrop]'
})

export class DragDropDirective {

    @Output() fileDropped = new EventEmitter<any>();

    @HostBinding('style.background-color') private background = '#E8EDFD';
    @HostBinding('style.opacity') private opacity = '1';

    // Dragover listener
    @HostListener('dragover', ['$event']) onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.background = '#9ecbec';
        this.opacity = '0.8';
    }

    // Dragleave listener
    @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.background = '#f5fcff';
        this.opacity = '1';
    }

    // Drop listener
    @HostListener('drop', ['$event']) public ondrop(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.background = '#f5fcff';
        this.opacity = '1';

        const files = [];
        for (let i = 0; i < evt.dataTransfer.files.length; i++) {
            const file = evt.dataTransfer.files[i];
            files.push(file);
        }
        if (files.length > 0) {
            this.fileDropped.emit(files);
        }
    }
}